import { CREATE_EVENT, GET_EVENT, CLEAN_EVENT, UPDATE_EVENT } from '../types';
import network from '../../services/network';
import { callApi } from './utils';

export const createEvent = data => {
  const action = () => network.createEvent(data);
  return callApi(action, CREATE_EVENT);
};

export const getEvent = id => {
  const action = () => network.getEvent(id);
  return callApi(action, GET_EVENT);
};

export const cleanEvent = () => {
  return {
    type: CLEAN_EVENT,
    payload: null,
  };
};

export const updateEvent = data => {
  const action = () => network.updateEvent(data);
  return callApi(action, UPDATE_EVENT);
};
